import { addYears, startOfYear, subMonths } from "date-fns";

/** 購入履歴一覧の期間フィルタの選択値。直近3ヶ月、または年（"2026"のような文字列） */
export const LAST_3_MONTHS_FILTER = "last3Months";

/** 注文日時での絞り込み範囲（Unix epoch milliseconds）。fromはその値を含み、toはその値を含まない */
export type PurchaseHistoryPeriod = {
  createdAtFrom: number | null;
  createdAtTo: number | null;
};

type Input = {
  /** 期間の基準時刻。フィルタ選択時に確定させ、ページをまたいでも同じ値を渡す */
  baseDate: Date;
  filter: string;
};

/**
 * フィルタの選択値を購入履歴APIに渡す期間へ変換する。
 * 年の境界は表示側（ブラウザ）のタイムゾーンで決める。
 * 常にどちらかの境界を返し、注文日時が欠落した注文が一覧に出ないようにする（Firestore直読み側と同じ挙動）
 */
export const toPurchaseHistoryPeriod = (
  input: Input
): PurchaseHistoryPeriod => {
  const { baseDate, filter } = input;

  if (filter === LAST_3_MONTHS_FILTER) {
    return {
      createdAtFrom: subMonths(baseDate, 3).getTime(),
      createdAtTo: null,
    };
  }

  // 年は4桁の数字だけを受け付ける。Number("")が0になるような値を年として扱わないため
  if (!/^\d{4}$/.test(filter)) {
    return {
      createdAtFrom: subMonths(baseDate, 3).getTime(),
      createdAtTo: null,
    };
  }

  const yearStart = startOfYear(new Date(Number(filter), 0, 1));
  return {
    createdAtFrom: yearStart.getTime(),
    createdAtTo: addYears(yearStart, 1).getTime(),
  };
};
